import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { authInterceptor } from './core/http-interceptors/auth.interceptor';
import { errorInterceptor } from './core/http-interceptors/error.interceptor';
import { BrowserSessionService } from './services/browser-session.service';
import { browserSessionInterceptor } from './core/http-interceptors/browser-session.interceptor';
import { AuthenticationService } from './services/authentication.service';

export function appInitializer() {
  const browserSessionService = inject(BrowserSessionService);
  const authenticationService = inject(AuthenticationService);
  sessionStorage.clear();
  browserSessionService.generateSession();
  authenticationService.loadAuthenticationToken();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(appInitializer),
    provideZoneChangeDetection({ runCoalescing: true, eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor, errorInterceptor, browserSessionInterceptor])
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'fr',
      lang: 'fr'
    })
  ]
};
